__webpack_require__.p = "/themes/platinum/assets/";